import { Http, HttpAuth, HttpUser } from "../../config/Http"
import { client_id, client_secret } from '../../config/App';
import { changeLoading } from "./loading.action"
import { changeAlert } from "./alert.action"
import { changeNotify } from "./notify.action"

export const actionTypes = {
    INDEX : 'INDEX_REGISTER',
    CHANGE: 'CHANGE_REGISTER',
    ERROR: 'ERROR_REGISTER',
    SUCCESS: 'SUCCESS_REGISTER',
    CHECK: 'CHECK_REGISTER',
}

export const index = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const setUserToken = (token) => dispatch => {
    localStorage.setItem('access_token', token);
}

export const getUser = () => dispatch => {
    return HttpUser.post('/user')
        .then(res => {
            if(typeof res !== 'undefined') {
                if(res.data.user) {
                    dispatch(index(res.data))
                    return 200;
                }
            }
        })
}

export const email = (data) => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Aguarde...'
    }))

    return Http.post('/email', data)
        .then(res => {
            if(res.data.success){
                return 'pagar';
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            if(erro.response) {
                dispatch(error(erro.response.data))
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        class: 'error',
                        msg: erro.response.data.msg
                    }))
                }
                if(erro.response.data.time === 100) {
                    return true;
                }
            }
        })
}

export const login = (telefone) => dispatch => {

    return Http.post('/oauth/token', {
        grant_type: 'password',
        client_id: client_id,
        client_secret: client_secret,
        username: telefone.replace(/[^a-zA-Z0-9]/g, ''),
        password: '123456'
    })
    .then(async (res) => {
        if(res.data.access_token) {
            await localStorage.setItem('access_token', res.data.access_token);
            return dispatch(getUser());
        }
    })
    .catch(error => {
        if(error.response) {
            if(error.response.status === 401 || error.response.status === 400) {
                return 400;
            }else {
                dispatch(changeNotify({
                    open: true,
                    class: 'error',
                    msg: 'Erro ao consultar dados',
                }))
            }   
        }
    })
}

export const register = (data) => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Aguarde reservando Bilhetes...'
    }))

    return Http.post('/register', data)
        .then(res => {
            if(res.data.access_token){
                dispatch(setUserToken(res.data.access_token));
                if(res.data.free === 200) {
                    dispatch(changeAlert({
                        open: true,
                        class: 'success',
                        msg: 'Bilhete reservado com sucesso'
                    }))
                    setTimeout(() => window.location.replace('/meus-bilhetes'), 1500)
                }else {
                    dispatch(checkBilhetes(data));
                }
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            if(erro.response) {
                dispatch(error(erro.response.data))
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        class: 'error',
                        msg: erro.response.data.msg
                    }))
                }
                if(erro.response.data.time === 100) {
                    return true;
                }
            }
        })
}

export const checkBilhetes = (data) => dispatch => {
    return HttpAuth.post('/check-bilhetes', data)
        .then(res => {
            if(res.data.limit) {
                dispatch(changeLoading({
                    open: false,
                }))

                dispatch(changeAlert({
                    open: true,
                    class: 'error',
                    msg: res.data.limit
                }))
            }

            if(res.data.await) {
                setTimeout(() => {
                    dispatch(checkBilhetes(data));
                }, 1500);
            }

            if(res.data.error) {
                dispatch(changeLoading({
                    open: false,
                }))
                dispatch(changeAlert({
                    open: true,
                    class: 'error',
                    msg: 'Os número(s) '+res.data.error+ ' acabaram de ser reservado(s) por outra pessoa'
                }))
            }
            if(!res.data.await && !res.data.error && !res.data.limit) {
                dispatch(changeLoading({
                    open: false,
                }))
                dispatch(index({steps: 2}))
            }
        })
}